import React from 'react';
import { List, Modal, Icon, Switch, Drawer } from 'antd-mobile';

import 'antd-mobile/dist/antd-mobile.css'; 
import './Info.css';

const Item = List.Item;

class Info extends React.Component  {
  constructor(props) {
    super(props);
    this.state = {
      info: {}
    };
  }

  componentWillMount() {
      let info = JSON.parse(sessionStorage.getItem('info'));
      console.log(info);
      this.setState({info: info});
  }

  componentDidUpdate() {
    // let c = window.document.body.scrollHeight; 
    // window.scroll(0, c); 
  }

  render() {
    return (
        <div style={{fontSize: '15px'}}>
          <List renderHeader={() => '专升本成绩公示：'}>
            <Item
                thumb={<Icon type="check-circle" style={{color: 'green'}}/>}
                // onClick={() => {}}
                extra={this.state.info.xm}
                >
                学生姓名
                </Item>
                <Item
                thumb={<Icon type="check-circle" style={{color: 'green'}}/>}
                // onClick={() => {}}
                extra={this.state.info.lqzy}
                >
                专业名称
                </Item>

                <Item
                extra={this.state.info.km1}
                // onClick={() => {}}
                >{this.state.info.km1name}</Item>
                <Item
                extra={this.state.info.km2}
                // onClick={() => {}}
                >{this.state.info.km2name}</Item>
                <Item
                extra={this.state.info.km3}
                // onClick={() => {}}
                >{this.state.info.km3name}</Item> 

                <Item
                extra={this.state.info.zcj}
                // onClick={() => {}}
                >总成绩</Item>
          </List>
        </div>
    );
  }
}

export default Info;